import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/common/authSlice';
import headerSlice from '../features/common/headerSlice';
import modalSlice from '../features/common/modalSlice';
import notificationsReducer from '../features/common/notificationsSlice';
import rightDrawerSlice from '../features/common/rightDrawerSlice';
import websiteSlice from '../features/common/websiteSlice';
import leadsSlice from '../features/leads/leadSlice';

const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  lead: leadsSlice,
  websites: websiteSlice,
  notifications: notificationsReducer,
  auth: authReducer,
};

export default configureStore({
  reducer: combinedReducer,
});
